<template>
    <v-app id="app" light>
        <Header />
        <!-- <button
            id="qsLoginBtn"
            class="btn btn-primary btn-margin"
            v-if="!authenticated"
            @click="login()">
              Log In
          </button>

          <button
            id="qsLogoutBtn"
            class="btn btn-primary btn-margin"
            v-if="authenticated"
            @click="logout()">
              Log Out
        </button>-->

        <router-view></router-view>
    </v-app>
</template>

<script>
import Profile from "./components/Profile.vue";
import Leaderboard from "./components/Leaderboard.vue";
import Header from "./components/Header.vue";
/* eslint-disable */

export default {
    name: "app",
    components: {
        Leaderboard,
        Header,
        Profile
    },
    data() {
        return {};
    },
    methods: {}
};
</script>

<style>
html {
    height: 100%;
    overflow-y: auto !important;
}

#app {
    overflow-y: auto;
    font-family: "Open Sans", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background: unset;
    background-image: url("./assets/background.jpg");
}
#app .v-table,
#app .v-datatable,
#app .v-datatable__actions {
    background: none;
}
.application--wrap {
    display: block !important;
}
</style>
